import { LatLng, LatLngBounds } from 'leaflet';
import { Place } from '../../models/Place';
import { useEffect, useMemo } from 'react';
import { AONB_Bounds } from '../../application/config';
import { useMap } from 'react-leaflet';

type MapControllerProps = {
	places: Place[];
};

const cloneAONBBounds = () =>
	new LatLngBounds(AONB_Bounds.getSouthWest(), AONB_Bounds.getNorthEast());

const calcBoundary = (pointList: LatLng[]) => {
	let boundary: LatLngBounds;

	switch (pointList.length) {
		case 0:
			boundary = cloneAONBBounds();
			break;
		case 1:
			boundary = cloneAONBBounds();
			boundary.extend(pointList[0]);
			break;
		default:
			boundary = new LatLngBounds(pointList[0], pointList[1]);
			for (let listNdx = 2; listNdx < pointList.length; listNdx++) {
				boundary.extend(pointList[listNdx]);
			}
			break;
	}

	return boundary;
};

export default function StoryMapController({ places }: MapControllerProps) {
	const map = useMap();
	const mapPois = useMemo(
		() =>
			places.map(
				(place) => new LatLng(place.location.lat, place.location.lng),
			),
		[places],
	);

	useEffect(() => {
		try {
			const boundary = calcBoundary(mapPois);
			if (!boundary.isValid()) {
				return;
			}
			map.fitBounds(boundary, {
				padding: [24, 24],
				maxZoom: 15,
			});
		} catch (e) {
			/* ignore fit failures */
		}
	}, [map, mapPois]);

	return null;
}
